import React from "react";
import styles from "./RiskProfile.module.scss";
import TableAccordion from "../../components/TableAccordion/TableAccordion";
import { useSelector } from "react-redux";
import MainLayout from "../../layouts/MainLayout/MainLayout";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import { useLocation, useParams } from "react-router-dom";
import useFetchOrganizationData from "../../actions/useFetchOrganizationData";

const RiskProfile = () => {
  const { orgId } = useParams();
  const location = useLocation();

  const modules = useSelector((state) => state.user.modules);
  const { risksData } = useSelector((state) => state.organization);

  // Fetch organization data when navigating through URL
  useFetchOrganizationData();

  // Extracting path from URL
  const lastIndex = location.pathname.lastIndexOf("/");
  const modifiedPath = location.pathname.substring(lastIndex);

  // Find the module object corresponding to the current path
  const currentModule = modules[orgId]?.find(
    (mod) => mod.path === modifiedPath,
  );

  return (
    <div>
      <MainLayout>
        <div className={styles.column}>
          <div className={styles.row}>
            <Breadcrumbs data={currentModule} />
          </div>
          <div className={styles.accordionTableWrapper}>
            <span className={styles.title}>RISK PROFILE</span>
            <TableAccordion risksData={risksData} />
          </div>
        </div>
      </MainLayout>
    </div>
  );
};

export default RiskProfile;
